import {JackpotType} from "../../services/jackpots/jackpot.constants";
import {OrbitTheme} from "../../themes/architecture/orbit-theme.interface";

export interface IJackpotWidgetImages {
    background: string;
    logo: string;
    backgroundLandscape?: string;
}

export function getJackpotWidgetImagesByType(theme: OrbitTheme, jackpotType: JackpotType): IJackpotWidgetImages | null {
    const images = theme.assets.images.jackpot_widget;
    switch (jackpotType) {
        case JackpotType.Daily:
            return {
                background: images.daily.background_png.toString(),
                logo: images.daily.logo_png.toString()
            }
        case JackpotType.HighNoon:
            return {
                background: images.high_noon.background_png.toString(),
                logo: images.high_noon.logo_png.toString()
            }
        case JackpotType.Twilight:
            return {
                background: images.twilight.background_png.toString(),
                logo: images.twilight.logo_png.toString()
            }
        case JackpotType.Party:
            return {
                background: images.party.background_png.toString(),
                logo: images.party.logo_png.toString()
            }
        case JackpotType.HourlyCaptain8:
            return {
                background: images.hourly_captain8.background_png.toString(),
                logo: images.hourly_captain8.logo_png.toString(),
                backgroundLandscape: images.hourly_captain8.background_landscape_png.toString()
            }
        case JackpotType.MillionaireGenie:
            return {
                background: images.millionaire_genie.background_png.toString(),
                logo: images.millionaire_genie.logo_png.toString()
            }
        case JackpotType.AgeOfGods:
            return {
                background: images.age_of_gods.background_png.toString(),
                logo: images.age_of_gods.logo_png.toString()
            }
        case JackpotType.Titan:
            return {
                background: images.titan.background_png.toString(),
                logo: ""
            }
        case JackpotType.JackpotKing:
            return {
                background: images.jackpot_king.background_png.toString(),
                logo: images.jackpot_king.logo_png.toString()
            }

        case JackpotType.VegasMillions:
            return {
                background: images.vegas_millions.background_png.toString(),
                logo: images.vegas_millions.logo_png.toString()
            }
        case JackpotType.JackpotBet: //to replace with actual jackpot bet assets
            return {
                background: images.hourly_captain8.background_png.toString(),
                logo: images.hourly_captain8.logo_png.toString(),
                backgroundLandscape: images.hourly_captain8.background_landscape_png.toString()
            }
        case JackpotType.Amusnet:
            return {
                background: images.amusnet.background_png.toString(),
                logo: images.amusnet.logo_png.toString()
            }
        default:
            return null;
    }

}